import { request, getApiErrorMessage } from '../../helpers';
import { clientService } from '../../services';
import { appActions } from './app.actions';
import { clientBasicTypes } from '../types';

const getClientBasicInfo = (clientId, tenantId) => {
  return dispatch => {
    dispatch(request(clientBasicTypes.GET_CLIENT_BASIC_REQUEST));

    clientService.getClientBasicInfo(clientId, tenantId)
      .then(
        (clientInfo) => {
          if (!clientInfo.enabled) {
            throw { error: 'Client is disabled', code: 'client-disabled' };
          }
          const firstUrl = (...values) =>
            values
              .map((value) => String(value || "").trim())
              .find(Boolean) || "";
          dispatch({
            type: clientBasicTypes.GET_CLIENT_BASIC_SUCCESS,
            payload: {
              ...clientInfo,
              privacyPolicy: firstUrl(
                clientInfo.privacyPolicy,
                clientInfo.privacy_policy,
                clientInfo.privacyPolicyUrl,
                clientInfo.privacyPolicyURI
              ),
              termsAndConditions: firstUrl(
                clientInfo.termsAndConditions,
                clientInfo.terms_and_conditions,
                clientInfo.termsAndCondition,
                clientInfo.termsAndConditionsUrl,
                clientInfo.termsAndConditionsURI,
                clientInfo.termsOfService,
                clientInfo.terms_of_service,
                clientInfo.termsOfUse,
                clientInfo.termsUrl,
                clientInfo.termsURI,
                clientInfo.terms
              ),
            }
          });
        },
        (errorPayload) => {
          const apiMessage = getApiErrorMessage(errorPayload);
          dispatch({
            type: clientBasicTypes.GET_CLIENT_BASIC_FAILURE,
            payload: apiMessage
          });
          dispatch(appActions.apiErrorMessage(apiMessage));
        }
      );
  };
};

export const clientActions = {
  getClientBasicInfo
};